import axios from "axios";
import axiosInterceptor from './AxiosInterceptor';

// export const BaseUrl = ENVIRONMENTS[SELECTED_ENVIRONMENT].baseurl || "";
export const baseUrl = process.env.REACT_APP_BASE_API_URL;
export const idmUrl = process.env.REACT_APP_IDM_URL;

axiosInterceptor();


const createCanonicalJSON=(obj)=> {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  
  if (Array.isArray(obj)) {
    return obj.map(createCanonicalJSON);
  }
  
  const sortedKeys = Object.keys(obj).sort();
  const canonicalObj = {};
  
  for (const key of sortedKeys) {
    canonicalObj[key] = createCanonicalJSON(obj[key]);
  }
  
  return canonicalObj;
}



// Generic signature generation function
export const generateSignature = async(payload, secret)=> {
  try {
    // Convert payload to canonical JSON string
    // sorting the payload
    const canonicalObj = createCanonicalJSON(payload);
    const canonicalPayload = JSON.stringify(canonicalObj);
    
    
    const encoder = new TextEncoder();
    const keyData = encoder.encode(secret);
    const messageData = encoder.encode(canonicalPayload);

    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "HMAC", hash: "SHA-256" },
      false,
      ["sign"]
    );

    const signatureBuffer = await crypto.subtle.sign("HMAC", cryptoKey, messageData);
    const signatureArray = new Uint8Array(signatureBuffer);
    const signature = btoa(String.fromCharCode(...signatureArray));

    return signature;
  } catch (error) {
    // console.error("Error generating signature:");
    throw error;
  }
}

// Generic API call function with signature
export const makeSecureAPICall = async(url, payload, options = {})=> {
  const secret = "PEB_5qKx$Y8zN3W@rV!6dLp#Tz!X$g^a7Mw2Bk%HjR^s*3vBz";
  
  try {
    // Generate signature for the payload
    const signature = await generateSignature(payload, secret);
    
    // Default headers
    const defaultHeaders = {
      'Content-Type': 'application/json',
      'X-Signature': signature, // Add signature to headers
      ...options.headers // Allow additional headers
    };
    
    // Default axios config
    const defaultConfig = {
      withCredentials: true,
      ...options,
      headers: defaultHeaders
    };
    
    const { data } = await axios.post(url, payload, defaultConfig);
    return data;
    
  } catch (error) {
    // Handle authentication errors
    if (error.response?.status === 401 || error.response?.status === 403) {
      window.location.replace(idmUrl);
    }
    throw error;
  }
}